import { Col, Row, Spin } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router";
import { Alerta } from "../../../../constants";
import ActionBar from "../../../../components/action-bar";
import ActionButton from "../../../../components/action-button";
import TextAnexo from "../../../../components/text-anexo";
import TextItem from "../../../../components/text-item";
import useFormatter from "../../../../hooks/useFormatter";
import useLoading from "../../../../hooks/useLoading";
import { certificadoSelector, fetchCertificado, isEditableSelector } from "../../../../store/empresa";
import { openPopup } from "../../../../util/window";
import useModulo from "../../../../hooks/useModulo";
import { certificadosAlertaNivelSelector } from "../../../../store/empresa";
import { useLocation } from "react-router";
import { useState } from "react";
import TarefasDrawer from "../../licencas/_tarefasDrawer";

export default function EmpresaCertificadoDetailPage() {
  const { t } = useTranslation();
  const isEditable = useSelector(isEditableSelector);
  const certificado = useSelector(certificadoSelector);
  const { formatDateTime } = useFormatter();
  const nivel = useSelector(certificadosAlertaNivelSelector);
  const loading = useLoading(fetchCertificado.typePrefix);
  const history = useHistory();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const id = match.params.id;
  const { moduloBasePath } = useModulo();
  const location = useLocation();
  const pathname = location.pathname;
  const origem = pathname.substring(pathname.indexOf("/empresas"));
  const modulo = pathname.split("/")[1];
  const [tarefasDrawerVisible, setTarefasDrawerVisible] = useState(false);

  const isNA = nivel === Alerta.Nivel.NA.id || nivel === Alerta.Nivel.inativo.id;

  const handleEdit = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/certificados/${id}/edit`);
  };

  const handleBack = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/certificados`);
  };

  const handleLogs = () => {
    openPopup(`/logs?categoria=/empresas/${empresaId}/certificados/${id}/`, `logs_/empresas/${empresaId}/certificados/${id}/`);
  };

  return (
    <Spin spinning={loading}>
      <TarefasDrawer visible={tarefasDrawerVisible} origem={origem} modulo={modulo} empresaId={empresaId} onClose={() => setTarefasDrawerVisible(false)} />
      <ActionBar>
        <ActionButton.Tarefa disabled={isNA} onClick={() => setTarefasDrawerVisible(true)} />
        {isEditable && <ActionButton.Edit onClick={handleEdit} disabled={isNA} />}
        <ActionButton.Back onClick={handleBack} />
        <ActionButton.Logs noTitle onClick={handleLogs} />
      </ActionBar>
      <Row gutter={[16, 8]}>
        <Col flex="400px">
          {" "}
          <TextItem label={t("Sujeito")}>{certificado?.sujeito}</TextItem>{" "}
        </Col>
        <Col flex="400px">
          {" "}
          <TextItem label={t("Emissor")}>{certificado?.emissor}</TextItem>{" "}
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="200px">
          <TextItem label={t("Válido De")}>{formatDateTime(certificado?.dataInicial)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label={t("Válido Até")}>{formatDateTime(certificado?.dataFinal)}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px">
          <TextAnexo label={t("Arquivo")} value={certificado?.arquivo} />
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="200px">
          <TextItem label={t("Senha")}>{certificado?.senha}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="200px">
          <TextItem label="Criado em">{formatDateTime(certificado?.createdAt)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label="Alterado em">{formatDateTime(certificado?.updatedAt)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label="Id">{empresaId}</TextItem>
        </Col>
      </Row>
    </Spin>
  );
}
